<input #search_input
       id="search_input_left_menu"
       type="text"
       placeholder="Search board or project"
       (input)="onWrite(search_input.value)"
       (keydown.esc)="onEscDown($event)"
       [value]="(stringSearch$ | async)"
>
